import { useEffect, useState } from 'react';
import { authApi } from '../api/phase12Client';
import { useAuth } from '../context/AuthContext';

export function AccountPage() {
  const { user, authRequired, logout } = useAuth();
  const [cur, setCur] = useState(''); const [nw, setNw] = useState(''); const [msg, setMsg] = useState<string | null>(null);
  const [users, setUsers] = useState<any[]>([]);
  const [nu, setNu] = useState({ username: '', password: '', full_name: '', role: 'analyst' });
  const isAdmin = user?.role === 'admin';

  const loadUsers = () => { if (isAdmin && authRequired) authApi.users().then(setUsers).catch(() => setUsers([])); };
  useEffect(loadUsers, [isAdmin, authRequired]);

  const change = async () => {
    setMsg(null);
    try { await authApi.changePassword(cur, nw); setMsg('Password changed.'); setCur(''); setNw(''); }
    catch (e) { setMsg(String(e)); }
  };
  const create = async () => {
    setMsg(null);
    try { await authApi.createUser({ ...nu, full_name: nu.full_name || undefined }); setNu({ username: '', password: '', full_name: '', role: 'analyst' }); loadUsers(); setMsg('User created.'); }
    catch (e) { setMsg(String(e)); }
  };

  if (!authRequired) return <div><h1 className="page-title">Account</h1><p className="page-subtitle">Authentication is disabled in this environment (PM_AUTH_DISABLED=1).</p></div>;

  return (
    <div>
      <h1 className="page-title">Account & Users</h1>
      <p className="page-subtitle">Signed in as <strong>{user?.username}</strong> ({user?.role}). <button className="btn-link" onClick={logout}>Sign out</button></p>
      {msg && <div className="card" style={{ fontSize: '0.85rem' }}>{msg}</div>}
      <div className="grid-2">
        <div className="card">
          <h3>Change password</h3>
          <label className="field-label">Current password</label>
          <input className="field" type="password" value={cur} onChange={(e) => setCur(e.target.value)} />
          <label className="field-label">New password (min 8 characters)</label>
          <input className="field" type="password" value={nw} onChange={(e) => setNw(e.target.value)} />
          <button className="btn-primary" style={{ marginTop: '0.75rem' }} onClick={change} disabled={nw.length < 8}>Update</button>
        </div>
        {isAdmin && (
          <div className="card">
            <h3>Create user</h3>
            <label className="field-label">Username</label>
            <input className="field" value={nu.username} onChange={(e) => setNu({ ...nu, username: e.target.value })} />
            <label className="field-label">Full name</label>
            <input className="field" value={nu.full_name} onChange={(e) => setNu({ ...nu, full_name: e.target.value })} />
            <label className="field-label">Temporary password</label>
            <input className="field" type="password" value={nu.password} onChange={(e) => setNu({ ...nu, password: e.target.value })} />
            <label className="field-label">Role</label>
            <select className="field" value={nu.role} onChange={(e) => setNu({ ...nu, role: e.target.value })}>
              <option value="analyst">Analyst</option><option value="viewer">Viewer</option><option value="admin">Admin</option>
            </select>
            <button className="btn-primary" style={{ marginTop: '0.75rem' }} onClick={create} disabled={nu.username.length < 3 || nu.password.length < 8}>Create</button>
          </div>
        )}
      </div>
      {isAdmin && (
        <div className="card">
          <h3>Users</h3>
          <table className="data-table">
            <thead><tr><th>Username</th><th>Name</th><th>Role</th><th>Active</th><th>Last login</th><th></th></tr></thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.username}>
                  <td>{u.username}</td><td>{u.full_name || '—'}</td><td>{u.role}</td><td>{u.active ? 'yes' : 'no'}</td><td>{u.last_login_at || '—'}</td>
                  <td>{u.username !== user?.username && (
                    <button className="btn-link" onClick={() => authApi.setActive(u.username, !u.active).then(loadUsers)}>{u.active ? 'Deactivate' : 'Activate'}</button>
                  )}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
